//#region src/core/i18n/locales/pl.ts
var pl_default = {
	buttons: {
		play: "Odtwórz",
		pause: "Wstrzymaj",
		replay: "Odtwórz ponownie",
		mute: "Wycisz",
		unmute: "Wyłącz wyciszenie"
	},
	seek: {
		forward: "Przewiń do przodu o {seconds} s",
		backward: "Przewiń do tyłu o {seconds} s"
	},
	fullscreen: {
		enter: "Pełny ekran",
		exit: "Wyjdź z pełnego ekranu"
	},
	captions: {
		enable: "Włącz napisy",
		disable: "Wyłącz napisy"
	},
	pip: {
		enter: "Obraz w obrazie",
		exit: "Wyjdź z trybu obraz w obrazie"
	},
	live: {
		playing: "Odtwarzanie na żywo",
		seekToEdge: "Przejdź na transmisję na żywo",
		badge: "Na żywo"
	},
	cast: {
		start: "Rozpocznij przesyłanie",
		stop: "Zatrzymaj przesyłanie",
		connecting: "Łączenie"
	},
	airplay: {
		start: "Uruchom AirPlay",
		stop: "Zatrzymaj AirPlay"
	},
	slider: { seek: "Przewijanie" },
	time: {
		current: "Aktualny czas",
		duration: "Czas trwania",
		remaining: "Pozostały czas",
		elapsedSuffix: "{duration} czasu, który upłynął",
		durationSuffix: "{duration} czasu trwania",
		remainingSuffix: "Pozostało {duration}",
		showElapsed: "Pokaż upływ czasu, {duration}.",
		showDuration: "Pokaż czas trwania, {duration}.",
		showRemaining: "Pokaż pozostały czas, {duration}.",
		toggleElapsed: "Przełącz między czasem, który upłynął, a pozostałym czasem.",
		toggleDuration: "Przełącz między czasem trwania a pozostałym czasem.",
		position: "{current} z {duration}",
		unknown: "Multimedia nie zostały załadowane, czas jest nieznany."
	},
	playback: { rate: "Prędkość odtwarzania {rate}" },
	volume: {
		mutedValue: "{percent}, wyciszono",
		muted: "Wyciszono",
		label: "Głośność",
		value: "Głośność {value}"
	},
	status: {
		captionsOn: "Napisy włączone",
		captionsOff: "Napisy wyłączone",
		paused: "Wstrzymano",
		playing: "Odtwarzanie",
		fullscreen: "Pełny ekran",
		pip: "Obraz w obrazie",
		exitPip: "Wyjdź z obrazu w obrazie",
		seekedTo: "Przewinięto do {time}"
	},
	container: { label: "Odtwarzacz multimediów" },
	errors: {
		aborted: "Odtwarzanie zostało przerwane",
		network: "Błąd sieci spowodował częściowe niepowodzenie pobierania materiału wideo.",
		decode: "Odtwarzanie materiału wideo zostało przerwane z powodu uszkodzonego pliku wideo lub z powodu użycia funkcji multimediów nieobsługiwanych przez Twoją przeglądarkę.",
		source: "Materiał wideo nie może zostać załadowany, ponieważ wystąpił problem z serwerem lub siecią albo format materiału wideo nie jest obsługiwany",
		encrypted: "Materiał jest zaszyfrowany, a nie mamy kluczy do jego odszyfrowania.",
		unplayable: "Ten materiał nie jest obsługiwany przez odtwarzacz.",
		title: "Coś poszło nie tak.",
		unexpected: "Wystąpił błąd. Spróbuj ponownie."
	},
	common: {
		empty: "",
		ok: "Zamknij"
	},
	menu: {
		settings: "Ustawienia",
		quality: "Jakość",
		audio: "Dźwięk",
		default: "Domyślne",
		speed: "Szybkość",
		captions: "Napisy",
		playbackRate: "Prędkość odtwarzania",
		back: "Wstecz",
		off: "Wyłączone",
		auto: "Auto",
		autoWithLabel: "Auto ({label})",
		subtitles: "Napisy"
	}
};
//#endregion
export { pl_default as default };

//# sourceMappingURL=pl.js.map